import '@vaadin/checkbox';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-checkbox';
@customElement(tagName)
export class TmCheckbox extends TmBaseComponent {
    @property({ type: String })
    public label?: string;

    @property({ type: String })
    public value?: string;

    @property({ type: Boolean, attribute: true, reflect: true })
    public checked = false;

    @property({ type: Boolean, attribute: true, reflect: true })
    public indeterminate = false;

    @property({ type: Boolean, attribute: true, reflect: true })
    public disabled = false;

    protected render() {
        return html`
            <vaadin-checkbox
                @checked-changed=${(e: CustomEvent) => {
                    if (e.detail.value === this.checked) {
                        return;
                    }
                    const checkedChangedEvent = new CustomEvent('checked-changed', {
                        detail: e.detail,
                    });
                    this.checked = e.detail.value;
                    this.dispatchEvent(checkedChangedEvent);
                }}
                class="w-full"
                label=${this.label ?? ''}
                value=${this.value ?? ''}
                ?checked=${this.checked}
                ?disabled=${this.disabled}
                ?indeterminate=${this.indeterminate}
            >
            </vaadin-checkbox>
        `;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --background-checked: var(--brand-primary);
                    --border-checked: var(--brand-primary);
                    --border: var(--jh-color-gray-300);
                    --checkbox: var(--jh-color-gray-0);
                    --label: var(--jh-color-gray-900);
                }
                :host([theme='dark']) {
                    --background-checked: var(--brand-100);
                    --border-checked: var(--brand-100);
                    --border: var(--jh-color-gray-400);
                    --checkbox: var(--jh-color-gray-900);
                    --label: var(--jh-color-gray-100);
                }
                vaadin-checkbox::part(checkbox) {
                    width: var(--vaadin-checkbox-size, 1em);
                    height: var(--vaadin-checkbox-size, 1em);
                    background-color: transparent;
                    border: 1px solid var(--border);
                    box-shadow: inset 0 0 0 var(--_input-border-width, 0) var(--_input-border-color);
                }
                vaadin-checkbox[checked]::part(checkbox) {
                    background-color: var(--background-checked);
                    border-color: var(--border-checked);
                }
                vaadin-checkbox[indeterminate]::part(checkbox) {
                    background-color: var(--background-checked);
                    border-color: var(--border-checked);
                }
                vaadin-checkbox[disabled]::part(checkbox) {
                    background-color: var(--jh-color-gray-100);
                    border-color: var(--jh-color-gray-300);
                }
                :host::part(checkbox)::before {
                    margin-top: -2px;
                }
                :host([checked])::part(checkbox)::after {
                    top: -2px;
                    left: -2px;
                    color: var(--checkbox);
                }
                vaadin-checkbox > label {
                    color: var(--label);
                    font-size: 14px;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmCheckbox;
    }
}
